import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Store } from '@ngrx/store';
import { selectTrivagoReference } from '@store/router/router.selector';
import { filter, take } from 'rxjs/operators';

@Injectable()
export class TrivagoService {
  constructor(private readonly cookieService: CookieService, private readonly store: Store) {
    this.store
      .select(selectTrivagoReference)
      .pipe(
        filter((value) => value),
        take(1),
      )
      .subscribe((trivagoReference) => {
        this.cookieService.set('trv_reference', trivagoReference, {
          expires: 1,
          domain: '.almundo.com.ar',
          path: '/',
        });
      });
  }
}
